import utils from '../utils.js';
import store from "../../store/store";

export default {
    subscribe_users_channel (bot_code, sender_id, channel) {
        let subscribeChannel = utils.generateSubscribe(bot_code, sender_id, channel);
        if (store.state.scClient) {
            return store.state.scClient.subscribe(subscribeChannel)
        } else {
            return null
        }

    }
}
